import { observable, action, makeObservable } from "mobx";

const initialState = {
  isUserLogin: false,
};

class LoginStore {
  isUserLogin = initialState.isUserLogin;

  constructor() {
    makeObservable(this, {
      isUserLogin: observable,
      isUserLoggedIn: action,
      logout: action
    });
  }

  isUserLoggedIn() {
    return fetch("/api/user/islogin/", {
      method: "get",
      headers: { "Content-Type": "application/json" },
    });
  }

  logout() {
    return fetch("api/user/logout/", {
      method: "post",
      headers: { "Content-Type": "application/json" },
    });
  }
}

export default LoginStore;



// WEBPACK FOOTER //
// ./src/stores/LoginStore.js